import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const UseCases = () => {
    const { t } = useLanguage();
    const styles = {
        section: {
            padding: '100px 32px',
            backgroundColor: '#FFFFFF',
        },
        container: {
            maxWidth: '1100px',
            margin: '0 auto',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '48px',
            textAlign: 'center',
            color: '#2B2B2B',
        },
        highlight: {
            color: '#3457D5',
        },
        card: {
            backgroundColor: '#F9F9F9',
            padding: '48px',
            borderRadius: '24px',
            border: '1px solid #E5E5E5',
            marginBottom: '32px',
        },
        text: {
            fontSize: '22px',
            color: '#414141',
            lineHeight: '1.7',
            marginBottom: '32px',
        },
        statsGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '24px',
        },
        statCard: {
            backgroundColor: '#FFFFFF',
            padding: '32px',
            borderRadius: '16px',
            border: '1px solid #E4ECFF',
            textAlign: 'center',
        },
        statNumber: {
            fontSize: '48px',
            fontWeight: '800',
            background: 'linear-gradient(135deg, #3457D5 0%, #F28C46 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: '8px',
        },
        statLabel: {
            fontSize: '16px',
            color: '#6E6E6E',
        },
        footer: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#3457D5',
            fontWeight: '600',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.text.fontSize = '18px';
        styles.card.padding = '32px 24px';
        styles.statsGrid.gridTemplateColumns = '1fr';
    }

    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <h2 style={styles.h2}>
                    {t('useCases.title')}<span style={styles.highlight}>{t('useCases.titleHighlight')}</span>
                </h2>

                <div style={styles.card}>
                    <p style={styles.text}>
                        {t('useCases.description')}
                    </p>

                    <div style={styles.statsGrid}>
                        <div style={styles.statCard}>
                            <div style={styles.statNumber}>60%</div>
                            <div style={styles.statLabel}>{t('useCases.stats.retrieval')}</div>
                        </div>
                        <div style={styles.statCard}>
                            <div style={styles.statNumber}>200+</div>
                            <div style={styles.statLabel}>{t('useCases.stats.saved')}</div>
                        </div>
                    </div>
                </div>

                <p style={styles.footer}>
                    {t('useCases.footer')}
                </p>
            </div>
        </section>
    );
};

export default UseCases;
